import {
  FETCH_ACTIVITY_LOG_FULFILLED,
  FETCH_ACTIVITY_LOG_PENDING,
  FETCH_ACTIVITY_LOG_REJECTED,
  CLEAR_ACTIVITY_LOG,
} from "../actions/activityLog.action.js";

let initialState = {
  isLoading: true,
  activityLogList: [],
  maxSize: null,
  activityLogListFail: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ACTIVITY_LOG_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_ACTIVITY_LOG_FULFILLED:
      console.log(action);
      return {
        ...state,
        activityLogList: action.data.activity,
        maxSize: action.data.max_limit,
        isLoading: false,
      };
    case FETCH_ACTIVITY_LOG_REJECTED:
      return {
        ...state,
        activityLogListFail: action.error,
        isLoading: false,
      };
    case CLEAR_ACTIVITY_LOG:
      console.log("activity cleared!");
      return {
        ...state,
        activityLogList: [],
        isLoading: false,
      };
    default:
      return state;
  }
};

export default reducer;
